// extracted by mini-css-extract-plugin
export var item = "social-links-module--item--7Myyp";
export var container = "social-links-module--container--2RgMP";